// extracted by mini-css-extract-plugin
export default {"main":"AccountActivated_main__lyS3S","title":"AccountActivated_title__j1SUb","button":"AccountActivated_button__DFMbB","logo":"AccountActivated_logo__H5hFi"};